<template>
  <div class="legal">
    <div class="legal__header">
      <div class="legal__header-eaimms">
        <EaimmsLogo />
      </div>
      <div class="legal__header-title typo-medium-text">
        {{ $t('iubenda.terms_and_conditions') }}
      </div>
    </div>
    <div class="legal__content">
      <Loader v-if="isLoading" />
      <div class="legal__content-nav" v-if="!isLoading">
        <div class="links-nav">
          <a
            v-for="(link, index) in navigationLinks"
            :key="index"
            :href="`#${link.href}`"
            @click="setActiveClass"
            :class="{'links-nav__link': true, 'links-nav__link--active': index === 0 }"
          >
            {{ link.label }}
          </a>
        </div>
      </div>
      <div
        class="legal__content-main"
        v-html="termsAndConditionsData"
        v-if="!isLoading"
      >
      </div>
    </div>
  </div>
  <Footer />
</template>

<script setup>
import { ref, onMounted } from 'vue';
import useAjax from '@/functions/use_ajax';
import I18n from 'i18n-js';

import EaimmsLogo from '@/images/logo-icon-and-text.svg';
import Loader from '@/components/generic/loader.vue';
import Footer from '@/components/generic/footer.vue';

const ajax = useAjax();

const isLoading = ref(true);
const termsAndConditionsData = ref(null);

const navigationLinks = [
  { href: '', label: I18n.t('iubenda.introduction') },
  { href: 'terms-of-use', label: I18n.t('iubenda.terms_of_use') },
  { href: 'liability-and-indemnification', label: I18n.t('iubenda.liability_and_indemnification') },
  { href: 'common-provisions', label: I18n.t('iubenda.common_provisions') },
  { href: 'exception-for-european-consumers', label: I18n.t('iubenda.definitions_and_legal_references') },
];

onMounted(() => {
  loadData();
});

/**
 * Load iubenda data
 */
async function loadData() {
  let { ok, data } = await ajax('/terms_and_conditions');

  if (ok) {
    termsAndConditionsData.value = data.terms_and_conditions
    isLoading.value = false;
  }
}

/**
 * adds active class to nav items
 */
function setActiveClass(e) {
  const links = document.querySelectorAll('.links-nav__link');
  links.forEach(link => link.classList.remove('links-nav__link--active'));

  e.target.classList.add('links-nav__link--active');
}
</script>
